import { Country } from 'src/enums/countries'
import { establishmentTypes } from 'src/enums/establishmentTypes'

interface CommercialField {
  label: string
  value: string
  type: 'text' | 'number' | 'select'
  options?: { label: string; value: number }[]
}

const commercialFields: IDictionary<CommercialField> = {
  nit: { label: 'NIT', value: 'nit', type: 'text' },
  nrc: { label: 'NRC', value: 'nrc', type: 'text' },
  businessName: { label: 'Razón social', value: 'name', type: 'text' },
  commercialName: {
    label: 'Nombre comercial',
    value: 'commercialName',
    type: 'text',
  },
  commercialAddress: {
    label: 'Dirección comercial',
    value: 'address',
    type: 'text',
  },
  department: { label: 'Departamento', value: 'department', type: 'text' },
  county: { label: 'Municipio', value: 'municipality', type: 'text' },
  comercialEstablishment: {
    label: 'Establecimiento comercial',
    value: 'comercialEstablishment',
    type: 'number',
  },
  establishmentType: {
    label: 'Tipo de establecimiento',
    value: 'establishmentType',
    type: 'select',
    options: establishmentTypes,
  },
  zip: { label: 'Código postal', value: 'postalCode', type: 'text' },
}

const commercialFieldsByCountry: Record<Country, IDictionary<CommercialField>> = {
  [Country.GT]: Object.fromEntries(
    Object.entries(commercialFields).filter(
      ([key]) => key !== 'nrc' && key !== 'establishmentType',
    ),
  ),
  [Country.SV]: Object.fromEntries(
    Object.entries(commercialFields).filter(([key]) => key !== 'zip'),
  ),
}

function getCommercialFields(country: Country): CommercialField[] {
  const commercialFields = commercialFieldsByCountry[country]
  return commercialFields !== undefined ? Object.values(commercialFields) : []
}

export { getCommercialFields }
